import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpErrorResponse } from '@angular/common/http';

import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { environment } from '../../environments/environment';

@Injectable()
export class PersonalService {

    private host: any = {};

    constructor(private client: HttpClient) {
        this.host['v1-personal'] = environment.host('v1-personal');
    }

    getFullPersonalAvatarByAccountId(accountId: string): Observable<any> {
        return this.client.request('GET', `${this.host['v1-personal']}/v1/data/personal/${accountId}`, {
            headers: { 'X-MyKronoz-Authorization': 'admin' },
            observe: 'response'
        }).pipe(
            map((response: HttpResponse<any>) => {
                console.debug('PersonalService.getFullPersonalAvatarByAccountId.map', response);
                return response.body;
            }),
            catchError((response: HttpErrorResponse) => {
                console.debug('PersonalService.getFullPersonalAvatarByAccountId.catchError', response);
                if (response.error instanceof ErrorEvent) {
                } else {
                }
                return throwError(() => ({ status: response.status }));
            })
        );
    }
}
